import { useRef as w, useId as y, useState as z, useCallback as i } from "react";
import { getActiveElement as u, isHTMLElement as B } from "../../../utils/dom/index.js";
import { focus as A } from "../../../utils/focus/index.js";
import { isInputElement as l, isActiveElement as S } from "../../../utils/tabbable/index.js";
import { useMenuContext as G } from "../useMenuContext.js";
import { useMenuDescendant as J } from "../useMenuDescendantsContext.js";
import { useMergeRefs as K } from "../../../utils/hooks/useMergeRefs.js";
import { useChangeEffect as N } from "../../../utils/hooks/useChangeEffect.js";
const Q = (c) => (
  // this will catch `menuitem`, `menuitemradio`, `menuitemcheckbox`
  B(c) && !!c.getAttribute("role")?.startsWith("menuitem")
), a = () => l(u()), oe = (c = {}, T = null) => {
  const {
    onMouseEnter: I,
    onMouseMove: M,
    onMouseLeave: v,
    onClick: E,
    disabled: o,
    closeOnSelect: F,
    id: b,
    ...h
  } = c, {
    setFocusedIndex: r,
    focusedIndex: L,
    onClose: x,
    menuRef: e,
    opened: C,
    menuId: R,
    closeOnSelect: g
  } = G(), s = w(null), O = `${R}-menuitem-${y()}`, $ = b || O, [P, k] = z(!1), { index: m, register: D } = J({
    disabled: o
  }), H = K(D, s, T), f = i(
    (t) => {
      I?.(t);
      const n = a();
      if (k(n), o || n)
        return;
      const p = u();
      l(p) && e && e.contains(p) || r(m);
    },
    [r, m, o, I, e]
  ), W = i(
    (t) => {
      M?.(t);
      const n = u();
      !(l(n) && e && e.contains(n)) && s.current && !S(s.current) && f(t);
    },
    [f, M, e]
  ), j = i(
    (t) => {
      v?.(t);
      const n = a();
      k(n), !(o || n) && r(-1);
    },
    [r, o, v]
  ), q = i(
    (t) => {
      E?.(t), Q(t.currentTarget) && (t.defaultPrevented || (F ?? g) && x?.());
    },
    [E, x, F, g]
  ), d = m === L;
  return N(() => {
    if (!(!C || a()))
      if (d && !o && s.current) {
        const t = u();
        l(t) && e && e.contains(t) || A(s.current, {
          nextTick: !0,
          // wait until floating-ui has positioned the menu before focusing
          selectTextIfInput: !1,
          preventScroll: !1
        });
      } else e && !S(e) && !e.contains(u()) && A(e, {
        nextTick: !0,
        // wait until floating-ui has positioned the menu before focusing
        preventScroll: !1
      });
  }, [d, o, e, C]), {
    ...h,
    onClick: q,
    onMouseEnter: f,
    onMouseMove: W,
    onMouseLeave: j,
    ref: H,
    disabled: o,
    id: $,
    role: "menuitem",
    tabIndex: P ? -1 : d ? 0 : -1,
    "data-hover-disabled": !P
  };
};
export {
  oe as useMenuItem
};
//# sourceMappingURL=useMenuItem.js.map
